import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MouldDesignAdapter } from 'src/app/models/domain/adapters/mould-design-adapter';
import { ElementsService, MouldsService } from 'src/generated-clients/mould_design';

@Injectable({
  providedIn: 'root',
})
export class MouldDesignDataService {
  public constructor(
    private readonly mouldDesignApi: MouldsService,
    private readonly mouldDesignAdapter: MouldDesignAdapter,
    private readonly elementsService: ElementsService
  ) {}

  public getMouldCardByEquipmentNumber(equipmentNumber: string) {
    return this.mouldDesignApi.apiV2MouldsIdDesignAttributesGet(equipmentNumber).pipe(
      map((response) => {
        return this.mouldDesignAdapter.adaptToDomain(response.value);
      })
    );
  }

  public getEquipmentListByDesignId(designId: string): Observable<string[]> {
    return this.elementsService.apiV1ElementsIdMouldsGet(designId).pipe(
      map((response) => (Array.isArray(response.mouldIds) ? response.mouldIds : [])),
      catchError((error) => {
        console.error('Failed!', error);

        return of([]);
      })
    );
  }
}
